import React, { Component } from 'react'
import { CardDeck, Row, Col, Container, Card, Button, Modal } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.css';
import '../css/UpdateUserProfile.css';
import Select from "react-select";
import axiosConfig from '../config/axiosConfig'
import Swal from 'sweetalert2/dist/sweetalert2.js';
import AdvanceTableWithAdjustButton from '../components/Tables/AdvanceTableWithAdjustButton';

import '../css/AdvanceDeleteButtonTable.css'
import FeatherIcon from 'feather-icons-react'

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? "black" : "black",
        backgroundColor: state.isSelected ? "#7367f0" : "white",
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: "20px",
        borderColor: "#7367f0",
    }),
};

const firstDate = new Date();
const currentDate = new Date();
class AdjustTransaction extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            Value: 0.0,
            UserID: 0,
            Price: 0.0,
            // FromDate: '',
            Product: '',
            // ToDate: '',
            FromDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 2).toISOString().slice(0,16), //new Date(date.getFullYear(), date.getMonth(), 1);
            ToDate: new Date().toISOString().slice(0,16),
            MappingId: 0,
            createdDate: '',
            logdatetime: '',
            SelectedType: '',


            openModel: false,
            IsAmountSelected: false,

            TransactionDetaildata: [],
            PANs: [],
            Type: [
                { 'label': 'Quantity' },
                { 'label': 'Amount' },
            ],
            TransactionDetailcolumns: [
                { "HeaderText": "ID", "MappingColomn": "tranDetailId" },
                { "HeaderText": "Date", "MappingColomn": "logDateTime" },
                { "HeaderText": "VRN", "MappingColomn": "vrn" },
                { "HeaderText": "Name", "MappingColomn": "name" },
                { "HeaderText": "Pan", "MappingColomn": "pan" },
                { "HeaderText": "Amount", "MappingColomn": "amount" },
                { "HeaderText": "Quantity", "MappingColomn": "quantity" },
                { "HeaderText": "Price", "MappingColomn": "price" },
                { "HeaderText": "Product", "MappingColomn": "product" }

            ],
            UserBranchID: localStorage.getItem("selectedBranch")
        }


        this.onPANChange = this.onPANChange.bind(this);
        this.changeHandler = this.changeHandler.bind(this);

        this.showModel = this.showModel.bind(this)
        this.AdjustdCallback = this.AdjustdCallback.bind(this)
        this.closeModel = this.closeModel.bind(this)

        this.onChange = this.onChange.bind(this)
        this.TransactionSaved = this.TransactionSaved.bind(this)
        this.BindTransactionDetailGrid = this.BindTransactionDetailGrid.bind(this);

    }

    componentWillMount() {

    }
    componentDidMount() {
        const data = {
            UserBranchID: this.props.data.selectedBranchId,
        };

        /*Get PANs*/
        this.setState({
            PANs: []
        });
        axiosConfig
            .post("Portal/GetPANs", data)
            .then((res) => {

                for (var i = 0; i < res.data.pans.length; i++) {
                    this.setState((prevState) => ({

                        PANs: [
                            ...prevState.PANs,
                            {
                                value: res.data.pans[i].id,
                                label: res.data.pans[i].pan,
                                createdDate: res.data.pans[i].createdDate,
                            },
                        ],
                    }));
                }
            })
            .catch(function (error) { });

    }

    BindTransactionDetailGrid(e) {
        axiosConfig.post("Portal/GetTransactionDetails",
            {
                MappingId: this.state.MappingId,
                FromDate: this.state.FromDate,
                ToDate: this.state.ToDate,
                UserBranchID: this.props.data.selectedBranchId,
            }
        )
            .then(res => {
                this.setState({
                    TransactionDetaildata: res.data.trandetails,
                    UserBranchID: this.state.UserBranchID
                })

            })
            .catch(error => {
                Swal.fire({
                    title: error.response.data.errorMessage,
                    text: 'Some Error !',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })

    }

    AdjustdCallback = (ChildData) => {
        this.setState({ Product: ChildData.product });
        this.setState({ UserID: ChildData.tranDetailId });
        this.setState({ Price: ChildData.price });
        console.log(this.state.UserID);
        this.showModel();
    }

    showModel = (e) => {
        this.setState({ openModel: true });
    }

    closeModel(e) {
        this.setState({ openModel: false });
    }

   
    changeHandler(p) {
        var newState = {};
        newState[p.target.name] = p.target.value;
        this.setState(newState);
    }


    TransactionSaved = (e) => {
        axiosConfig.post("Portal/SaveAdjustedTransaction",
            {
                TransDetailId: this.state.UserID,
                Value: this.state.Value,
                IsAmount: this.state.IsAmountSelected,
                Product: this.state.Product,
                Price: this.state.Price,
                UserBranchID: this.state.UserBranchID
            }

        )
            .then(Response => {
                this.setState({ openModel: false });
                // this.BindSMSAndEmailGrid();
                Swal.fire({
                    icon: 'success',
                    title: Response.data.status.description,
                })

            })
            .catch(error => {
                this.setState({ openModel: false });
                Swal.fire({
                    title: error.res.data.errorMessage,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })

    }


    onChange(selectedOption) {

        console.log('selectedOption: ', selectedOption);

        if (selectedOption.label == 'Quantity') {
            this.setState({
                SelectedType: 'Quantity',
                IsAmountSelected: false,
            });
        }
        else if (selectedOption.label == 'Amount') {

            this.setState({
                SelectedType: 'Amount',
                IsAmountSelected: true,
            });
        }

    }

    async onPANChange(selectedOption) {


        this.setState({
            MappingId: selectedOption.value,
            createdDate: selectedOption.createdDate,
        });
    }


    render() {

        return (
            <>
                <Row className="p-3">
                    <Card className="p-3" style={{ width: "100%" }}>
                        <Card.Title>
                            <div className="pull-left">
                                Adjust Transaction
                                <br></br>
                            </div>
                        </Card.Title>

                        <Card.Body>
                            <Row className="justify-content-center align-items-center">
                                <div className="col-md-3 col-12">
                                    <label className="font-weight-bold">Choose PAN</label>
                                </div>
                                <div className="col-md-4 col-12">
                                    <div className="form-label-group">
                                        <Select
                                            className=""
                                            options={this.state.PANs}
                                            styles={customStyles}
                                            onChange={this.onPANChange}
                                        ></Select>
                                    </div>
                                </div>
                            </Row>
                            <Row className="justify-content-center align-items-center">
                                <div className="col-md-3 col-12">
                                    <label className="font-weight-bold text-right">From Date</label>
                                </div>
                                <div className="col-md-4 col-12">
                                    <div className="form-label-group">
                                        <input type="datetime-local" id="FromDate" name="FromDate" value={this.state.FromDate} onChange={this.changeHandler} className="form-control" min={this.state.createdDate} />
                                    </div>
                                </div>
                            </Row>
                            <Row className="justify-content-center align-items-center">
                                <div className="col-md-3 col-12">
                                    <label className="font-weight-bold text-right">To Date</label>
                                </div>
                                <div className="col-md-4 col-12">
                                    <div className="form-label-group">
                                        <input type="datetime-local" id="ToDate" name="ToDate" value={this.state.ToDate} onChange={this.changeHandler} className="form-control" min={this.state.FromDate} />
                                    </div>
                                </div>
                            </Row>
                            <div>
                                <div class="pull-middle">
                                    <div className="form-label-group">
                                        <Button
                                            className="btn-shell"
                                            variant="warning"
                                            onClick={this.BindTransactionDetailGrid}
                                        >
                                            Show
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 col-12">
                                <h6 className="pull-left">Transaction Details</h6>
                                <AdvanceTableWithAdjustButton parentAdjustdObjectCallback={this.AdjustdCallback} data={this.state.TransactionDetaildata} columns={this.state.TransactionDetailcolumns}>
                                </AdvanceTableWithAdjustButton>
                            </div>
                        </Card.Body>
                    </Card>
                </Row>
                <Modal show={this.state.openModel} onHide={this.closeModel} animation={true} centered style={{ zIndex: 99999 }}>
                    <Modal.Header closeButton>
                        <Modal.Title>Profile For Transaction </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={this.TransactionSaved}>
                            <div className="modal-body">
                                <label>Type: </label>
                                <div className="form-group">
                                    <Select
                                        className=""
                                        options={this.state.Type}
                                        styles={customStyles}
                                        onChange={this.onChange}

                                    ></Select>
                                </div>
                                <label>{this.state.SelectedType + ' Value'}</label>
                                <div className="form-group">
                                    <input type="text" className="form-control" name="Value" value={this.state.Value} onChange={this.changeHandler} required />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <Button variant="secondary" onClick={this.closeModel}>Close</Button>
                                <button className="btn btn-shell" >Save</button>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            </>

        );
    }
}

export default AdjustTransaction;









